import React, { useEffect, useRef } from "react";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";

import {
  pushPurchase,
  hotelCartItems,
  hotelCartValue,
  restaurantItemsFromState,
} from "../../utils/datalayer";

function SuccessView() {
  sessionStorage.clear();
  const { t } = useTranslation();

  const bookingParam = useSelector((s) => s.bookingParam);
  const restaurantHotel = useSelector((s) => s.restaurantHotel);
  const restaurant = useSelector((s) => s.restaurant);
  const hotelSettings = useSelector((s) => s.settings.hotelSettings);
  const location = useLocation();
  const purchaseFired = useRef(false);

  useEffect(() => {
    if (purchaseFired.current) return;

    const orderId = (bookingParam && bookingParam.orderId) || "";
    if (!orderId) return;

    const isRestaurantOnly =
      (bookingParam && bookingParam.reservationType === "R") ||
      (typeof location.pathname === "string" &&
        location.pathname.includes("restaurant"));

    const deposit = Number(
      (hotelSettings && hotelSettings.secure_restaurant_amount) || 0,
    );

    let items = [];
    let value = Number((bookingParam && bookingParam.totalPrice) || 0);

    if (isRestaurantOnly) {
      items = restaurantItemsFromState(restaurant, deposit);
      if (!value) value = Number(bookingParam.totalAmountToBlock) || 0;
    } else {
      const nights = (bookingParam && bookingParam.totalNights) || 1;
      const rooms = (bookingParam && bookingParam.rooms) || [];
      items = hotelCartItems(rooms, nights);
      const restItems = restaurantItemsFromState(restaurantHotel, deposit);
      if (restItems.length) items = items.concat(restItems);
      if (!value) value = hotelCartValue(rooms, nights);
    }

    if (!items.length && !value) return;

    pushPurchase(orderId, items, value);
    purchaseFired.current = true;
  }, [bookingParam, restaurant, restaurantHotel, hotelSettings, location.pathname]);

  return (
    <div className="flex items-center text-center  flex-col min-h-screen justify-center px-10">
      <FontAwesomeIcon
        icon={faCheck}
        className="text-5xl text-green-600 py-2"
      />

      <h2 className="text-2xl font-bold">{t("success_title")}</h2>
      <p className="my-6 text-xl leading-none font-semibold ">
        {t("success_subtitle")}
      </p>
      <p className="mb-2">{t("success_paragraph")}</p>
      <a href="tel:+33388719898" className="underline text-primary">
        +33 (0) 388719898
      </a>
      <span>{t("success_email")}</span>
      <a
        href="mailto: reservation@villarenelalique.com"
        className="underline text-primary"
      >
        {" "}
        reservation@villarenelalique.com
      </a>
      <p className="italic mt-5">{t("success_footer")}</p>
    </div>
  );
}

export default SuccessView;
